import request, { outSiteRequest, serviceV2 } from '@/utils/request'

const prefix = '/django_rest/rpa'

// taskBackend 为 legacy（旧版 Web）或 new（新版 Service）；仅用于前端分流，不透传给接口。
function sendTaskRequest (taskBackend, method, path, payload) {
  if (taskBackend === 'new') {
    return serviceV2[method](`/rpa${path}`, payload)
  }
  return request[method](`${prefix}${path}`, payload)
}

export default {
  getQrUrl (params) {
    return request.get(`${prefix}/wechat-qr/`, { params })
  },
  getTaskList ({ taskBackend, ...params } = {}) {
    return sendTaskRequest(taskBackend, 'get', '/task/launcher/', { params })
  },
  getTaskById ({ taskId, taskBackend }) {
    return sendTaskRequest(taskBackend, 'get', `/task/${taskId}/`)
  },
  saveTask ({ taskBackend, ...task }) {
    return sendTaskRequest(taskBackend, 'post', '/task/', task)
  },
  updateTask ({ taskBackend, ...task }) {
    return sendTaskRequest(taskBackend, 'put', `/task/${task.id}/`, task)
  },
  getTaskAction ({ taskBackend, ...params }) {
    return sendTaskRequest(taskBackend, 'get', `/task/${params.task_id}/action/`, { params })
  },
  updateTaskAction ({ taskBackend, ...params }) {
    return sendTaskRequest(taskBackend, 'post', `/task/${params.task_id}/action/`, params)
  },
  getTaskScreenshot ({ taskBackend, ...params }) {
    return sendTaskRequest(taskBackend, 'get', `/task/${params.task_id}/screenshot/`, { params })
  },
  getTaskControl ({ taskBackend, ...params }) {
    return sendTaskRequest(taskBackend, 'get', `/task/${params.task_id}/control/`, { params })
  },
  getDownloadResumeReportData (params) {
    return request.get(`${prefix}/report/download-resume/`, { params })
  },
  getPostingJobReportData (params) {
    return request.get(`${prefix}/report/posting-job/`, { params })
  },
  getResumeDownloadData (params) {
    return request.get(`${prefix}/download-record/`, { params })
  },
  getMonitorImage (url) {
    return outSiteRequest.get(url)
  },
  getEmailResumeList (params) {
    return request.get(`${prefix}/email-resume/`, { params })
  },
  getEmailResumeReportData (params) {
    return request.get(`${prefix}/email-resume/report/`, { params })
  },
  getCompanyTaskIp (companyId, params) {
    return request.get(`${prefix}/task/${companyId}/ip/`, { params })
  }
}
